module.exports = __webpack_public_path__ + "img/c2fb08f.jpg";